import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  QueryList,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { MatLegacySelect as MatSelect } from '@angular/material/legacy-select';
import {
  AlertTrigger,
  ScoreOption,
  createDefaultTrigger,
} from '../alerts-setup.models';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-score-alerts',
  templateUrl: './score-alerts.component.html',
  styleUrls: ['./score-alerts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScoreAlertsComponent {
  @Input() triggers: AlertTrigger[] = [];
  @Input() alertType: string;
  @Input() layout: string;
  @Input() scoreTypes: ScoreOption[] = [];
  @Input() thresholdSettingTypes: ScoreOption[] = [];
  @Input() selectedDeltaPeriod: number;
  @Input() deltaPeriods: number[] = [];

  @ViewChildren('selectorTriggerScore')
  triggerScoreFields: QueryList<MatSelect>;
  @ViewChildren('selectorTriggerThresholdSetting')
  triggerThresholdSettingFields: QueryList<MatSelect>;
  @ViewChildren('inputTriggerThreshold')
  triggerThresholdFields: QueryList<ElementRef>;

  onScoreChange(event: { value: string }, index: number) {
    this.triggers[index].threshold_setting = 'cross_above';
    if (event.value === 'sentiment') {
      this.triggers[index].threshold = 50;
    } else if (event.value === 'general_risk') {
      this.triggers[index].threshold = 5;
    } else if (event.value === 'esg_risk') {
      this.triggers[index].threshold = 4;
    } else if (event.value === 'immediate_risk') {
      this.triggers[index].threshold = 3.5;
    } else if (event.value === 'credit_risk') {
      this.triggers[index].threshold = 5.5;
    } else if (event.value === 'esg') {
      this.triggers[index].threshold = 5;
    } else if (event.value === 'eb_sim') {
      this.triggers[index].threshold = 5;
    } else if (event.value === 'eb_sim_risk') {
      this.triggers[index].threshold = 5;
    } else if (event.value === 'bb') {
      this.triggers[index].threshold = 5;
    }
    this.triggers[index].isDeltaAlert = false;
    this.triggers[index].additional_params.z_score_period = '7';
    this.triggers[index].additional_params.z_score_direction = '';
  }

  onDeltaSlideToggle(
    isDeltaActive: boolean,
    trigger: AlertTrigger,
    index: number,
  ) {
    if (isDeltaActive) {
      trigger.isDeltaAlert = true;
      if (trigger.threshold_setting === 'cross_above') {
        trigger.threshold_setting = '>=';
      } else if (trigger.threshold_setting === 'cross_below') {
        trigger.threshold_setting = '<=';
      } else if (!['>=', '<='].includes(trigger.threshold_setting)) {
        trigger.threshold_setting = '';
      }
    } else {
      trigger.isDeltaAlert = false;
      if (trigger.threshold_setting === '>=') {
        trigger.threshold_setting = 'cross_above';
      } else if (trigger.threshold_setting === '<=') {
        trigger.threshold_setting = 'cross_below';
      }
    }
    this.triggers[index] = trigger;
  }

  addTrigger() {
    this.triggers.push(createDefaultTrigger());
  }

  delTrigger(index: number) {
    this.triggers.splice(index, 1);
  }

  focusTriggerScore(index: number): void {
    this.triggerScoreFields.toArray()[index].focus();
  }

  focusTriggerThresholdSetting(index: number): void {
    this.triggerThresholdSettingFields.toArray()[index].focus();
  }

  focusTriggerThreshold(index: number): void {
    this.triggerThresholdFields.toArray()[index].nativeElement.focus();
  }
}
